// removed by extract-text-webpack-plugin
module.exports = {"toggler":"_26o4cuq53fCpgZtMC7oWB9","buttons":"_3veM_df1UHH2u-oWtMjOyr","citiesCheckbox":"_1mA2akcTwraEGXFkR37l__"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/GeographyChart/GeographyChartTypeWrapper.scss
// module id = 1326
// module chunks = 1